import {
  IAutoPolicy,
  IPolicyDriver,
  TPolicyVehicleFormValues,
} from '../../../interfaces';

import {
  updateRatingAddressOnPolicy,
  TUpdateRatingAdressOnPolicy,
} from './address';
import { getCheckoutProps } from './checkout';
import {
  addNewDriverToPolicy,
  updateDriverOnPolicy,
  TUpdateDriverOnPolicy,
} from './driver';
import { isRunHealthCheck, isStagedPolicyDirty } from './helpers';
import {
  addNewVehicleToPolicy,
  updateVehicleOnPolicy,
  TUpdateVehicleOnPolicy,
  getPolicyVehicleVinBlacklist,
} from './vehicle';

export * from './diffPolicy';
export * from './usePolicyHealthCheck';
export * from './policyHealthCheck';

export function getPolicyContainerHelpers(stagedPolicy: IAutoPolicy) {
  return {
    addNewDriverToPolicy: (driver: IPolicyDriver) =>
      addNewDriverToPolicy(driver, stagedPolicy),
    updateDriverOnPolicy: (opts: TUpdateDriverOnPolicy) =>
      updateDriverOnPolicy(opts, stagedPolicy),
    addNewVehicleToPolicy: (values: TPolicyVehicleFormValues) =>
      addNewVehicleToPolicy(values, stagedPolicy),
    getPolicyVehicleVinBlacklist: (editingVehicleVin: string) =>
      getPolicyVehicleVinBlacklist(editingVehicleVin, stagedPolicy),
    updateVehicleOnPolicy: (opts: TUpdateVehicleOnPolicy) =>
      updateVehicleOnPolicy(opts, stagedPolicy),
    updateRatingAddressOnPolicy: (opts: TUpdateRatingAdressOnPolicy) =>
      updateRatingAddressOnPolicy(opts, stagedPolicy),
    isStagedPolicyDirty,
    isRunHealthCheck,
    getCheckoutProps,
  };
}
